<template lang="pug">
.review-import
  .d-flex.mt-8(v-if="!errorItems.length")
    v-icon(color="success" size=28) $yzi-check-circle-solid
    .ml-6
      .mb-2.text-xl.font-semibold {{ $t('csv_import_success_title') }}
      div {{ $t('csv_import_success_description') }}

  div(v-else)
    .d-flex.mt-8.mb-10
      .flex-grow-1
        .mb-3.text-xl.font-semibold {{ $t('csv_import_error_title') }}
        span.font-bold {{ errorItems.length }} 
        span {{ errorItems.length > 1 ? 'customers are' : 'customer is' }} affected by these errors. You can fix it directly or reupload a new file.
        .d-flex.mt-4
          yc-checkbox.mr-3(v-model="ignoreErrors")
          .text-sm {{ $t('ignore_and_remove_all_rows_data') }}
      v-btn.button-sm(@click="reuploadCsv" outlined depressed) {{ $t('reupload_csv') }}
    
    template(v-if="!ignoreErrors")
      .d-flex.align-center
        v-spacer
        yc-pagination-custom(v-model="page" :parentPageSize.sync="itemsPerPage" :count="errorItems.length" text="Item list" attach)

      v-data-table(:headers="headers" :items="errorItems" :page.sync="page" :items-per-page="itemsPerPage" @page-count="pageCount = $event" hide-default-footer disable-sort)
        template(v-slot:item.column="{ item }")
          .text-capitalize(v-for="column in item.column") {{ column.field_name }}
        template(v-slot:item.type="{ item }")
          .text-capitalize(v-for="column in item.column") {{ column.datatype }}
        template(v-slot:item.sample="{ item }")
          div(v-for="column in item.column") {{ column.value }}
        template(v-slot:item.error="{ item }")
          .d-flex.align-center(v-if="item.action === 'forgive' || item.action === 'remove'")
            v-icon(color="success") $yzi-check-circle-solid
            .ml-2 Error fixed
          .d-flex.align-center(v-else)
            v-icon(color="danger") $yzi-alert-circle-solid
            .ml-2 {{ getErrorDescription(item.error) }}
        template(v-slot:item.action="{ item }")
          a.link-s.info--text(v-if="item.action === 'forgive' || item.action === 'remove'" @click="undoFix(item)") Undo fix
          div(v-else-if="item.action === 'fatal'")
          a.link-s.info--text(v-else @click="fixError(item)") Fix error
        
  .text-right.mt-4
    v-btn.button-md(@click="finish" color="info" depressed :loading="isLoading") {{ $t('finish') }}
  
  .dialogs
    y-dialog(v-if="showFixDialog" v-model="showFixDialog" max-width=568 fluid scrollable content-class="round-2xl")
      v-card
        v-card-title.px-4
          v-spacer 
          .text-xl.font-bold.ml-10 Fix import error
          v-spacer
          v-btn(icon @click="showFixDialog = false")
            v-icon mdi-close
        v-divider.mb-6 
        v-card-text.pt-4.pb-16.primary--text
          .text-lg.font-medium.mb-6 What you want to do with this error?
          v-item-group(mandatory @change="onChanged" flat)
            div(v-for="option in fixOptions" :key="option.id")
              v-item(v-slot="{ active, toggle }")
                .round-2xl.mt-4.pa-4(:style="active ? activeStyle : inactiveStyle" @click="toggle" flat rounded="lg")
                  .text-lg.font-medium.mb-1 {{ option.title }}
                  .text-sm.neutral500--text {{ option.description }}
        v-divider
        v-card-actions.px-6.py-3
          v-spacer
          v-btn.button-md(@click="showFixDialog = false" text) {{ $t('cancel') }}
          v-btn.button-md(@click="confirmFix" color="danger" depressed dark) {{ $t('confirm') }}
    
    y-dialog(v-if="showConfirmationDialog" v-model="showConfirmationDialog" max-width=568 fluid scrollable content-class="round-2xl")
      v-card
        v-card-text.pa-8.primary--text
          .text-xl.font-medium.mb-4 All of the contact with error will be discarded and not imported
          .text-md {{ $t('click_confirm_to_proceed') }}
        v-divider
        v-card-actions.px-6.py-3
          v-spacer
          v-btn.button-md(@click="showConfirmationDialog = false" text) {{ $t('cancel') }}
          v-btn.button-md(@click="confirm" color="danger" depressed dark) {{ $t('confirm') }}
    
    processing-dialog(v-if="isLoading" :open.sync="isLoading" persistent text="It's going to take a while. Feel free to leave this page anytime. We will email you once the process is completed." @done="closeProcessingDialog")
    
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ProcessingDialog from '@/components/module/upload/ProcessingDialog.vue'

export default {
  name: 'ReviewImport',
  props: ['data', 'inputFile', 'mapperFormData'],
  components: { ProcessingDialog },
  data: () => ({
    selectedItem: null,
    page: 1,
    pageCount: 0,
    itemsPerPage: 100,
    showFixDialog: false,
    showConfirmationDialog: false,
    fixOptions: [
      {
        id: 'remove_value',
        title: 'Remove value with error',
        description: 'The contact will be imported to your system. But the value in the column will not be available'
      },
      {
        id: 'remove_row',
        title: 'Remove customer',
        description: 'The customer will be completely removed. It will not appear in your customer list.'
      }
    ],
    selectedFixOption: null,
    activeStyle: {
      border: '1.5px solid #0C6DFF',
      borderRadius: '4px',
      padding: '16px',
      cursor: 'pointer'
    },
    inactiveStyle: {
      border: '1px solid var(--v-basic400)',
      borderRadius: '4px',
      padding: '16px',
      cursor: 'pointer'
    },
    isLoading: false,
    importStatusCheckInterval: null,
    recheckCount: 0,
    headers: [
      { text: 'Row', value: 'row' },
      { text: 'Ic', value: 'ic' },
      { text: 'Column', value: 'column' },
      { text: 'Data Type', value: 'type' },
      { text: 'Sample', value: 'sample' },
      { text: 'Error type', value: 'error' },
      { text: '', value: 'action' }
    ],
    ignoreErrors: false
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    errorItems() {
      const errors = []
      if (this.data) {
        this.data.forgivable_errors.forEach(item => {
          const details = item.details
          const error = {
            row: item.row_number,
            phone: item.phone,
            ic: item.ic,
            name: item.name,
            column: details,
            type: details,
            sample: details,
            error: item.error_type,
            action: '',
          }
          errors.push(error)
        })
        this.data.fatal_errors.forEach(item => {
          const error = {
            row: item.row_number,
            phone: item.phone,
            ic: item.ic,
            name: item.name,
            error: item.error_type,
            action: 'fatal',
          }
          errors.push(error)
        })
      }
      return errors
    }
  },
  created () {
    this.headers.map(item => {
      item.class = 'text-table-header'
    })
  },
  methods: {
    ...mapActions(['showMessage']),
    fixError(item) {
      this.selectedItem = item
      this.showFixDialog = true
    },
    onChanged(index) {
      this.selectedFixOption = this.fixOptions[index]
    },
    confirmFix() {
      this.selectedItem.action = ''
      if (this.selectedFixOption.id === 'remove_value') {
        this.selectedItem.action = 'forgive'
      } else if (this.selectedFixOption.id === 'remove_row') {
        this.selectedItem.action = 'remove'
      }
      this.showFixDialog = false
    },
    undoFix(item) {
      item.action = ''
    },
    finish() { 
      if (this.errorItems.length && this.errorItems.filter(error => error.action === 'forgive').length === 0) {
        this.showConfirmationDialog = true
        return
      }
      this.processCsv()
    },
    confirm() {
      this.showConfirmationDialog = false
      this.processCsv()
    },
    processCsv() {
      const form = this.mapperFormData
      this.errorItems.forEach(item => {
        if ((this.ignoreErrors || item.action === 'forgive') && item.ic) {
          form.append('forgive', item.ic)
        }
      })
      this.isLoading = true
      this.$axios.post(`/connect/${this.company.slug}/customers/import_csv/process`, form)
      .then(resp => {
        const processingId = resp.data.processing_id
        this.startCheckInterval(processingId)
      })
      .catch(() => {
        this.showMessage(['error', this.$t('error_message.unable_to_import_csv')])
        this.isLoading = false
      })
    },
    startCheckInterval(id) {
      this.recheckCount = 0
      clearInterval(this.importStatusCheckInterval)
      this.importStatusCheckInterval = setInterval(() => {
        this.recheckCount++
        this.checkImportStatus(id)
        if (this.recheckCount > 84) {
          clearInterval(this.importStatusCheckInterval)
        }
      }, 5000)
    },
    checkImportStatus(processingId) {
      this.$axios.get(`/connect/${this.company.slug}/background_processings/${processingId}`)
      .then(resp => {
        const status = resp.data.status
        if (status == 'completed') {
          this.showMessage(['success', 'Customers imported successfully'])
          this.$router.push('/admin/clinic/patient')
          clearInterval(this.importStatusCheckInterval)
        } else if (status == 'error') {
          this.showMessage(['error', 'Unable to import customers.'])
          clearInterval(this.importStatusCheckInterval)
        }
      })
      .catch(() => {
        this.showMessage(['error', this.$t('error_message.unable_to_import_csv')])
        clearInterval(this.importStatusCheckInterval)
      })
    },
    getErrorDescription(type) {
      switch (type) {
        case 'INVALID_VALUE':
          return 'Invalid value'
        case 'PHONE_REQUIRED':
          return 'No phone number'
        case 'NAME_REQUIRED':
          return 'No name'
        case 'INVALID_PHONE_NUMBER':
          return 'Invalid phone number'
        case 'DUPLICATE_PHONE_NUMBER':
          return 'Duplicate phone number'
      }
      return 'Unknown error'
    },
    closeProcessingDialog() {
      this.isLoading = false
      this.$router.push('/admin/clinic/patient')
    },
    reuploadCsv() {
      location.href = '/admin/clinic/patient/import'
    }
  }
}
</script>
